
export enum enumAudioLinkSource {
  UploadedFile = 'UploadedFile', // a file that has been uploaded into Google Cloud Storage
  SoundCloud = 'SoundCloud', // a SoundCloud audio
}
